<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { useLearningAuthStore } from '@stores/auth'
import { useRouter } from 'vue-router'

const { resetAuth } = useLearningAuthStore()
const { userLogging } = storeToRefs(useLearningAuthStore())
const router = useRouter()

const isShowNpMenu = ref(false)

const toggleSpMenu = () => {
  if (window.innerWidth < 992) {
    isShowNpMenu.value = !isShowNpMenu.value
  } else {
    isShowNpMenu.value = false
  }
}

/*
 * アカウントメニュー関連
 */

const isVisibleAccountMenu = ref(false)

const accountMenu = [
  {
    name: '登録情報の確認・変更',
    path: '/user/account/input'
  },
  {
    name: 'メールアドレスの変更',
    path: '/user/mail'
  },
  {
    name: 'パスワードの変更',
    path: '/user/password/edit'
  },
  {
    name: 'ログアウト',
    path: 'logout'
  }
]

onMounted(() => {
  document.addEventListener('click', onClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onClickOutside)
})

const accountMenuClick = (path) => {
  // console.log('accountMenuClick', path)
  if (path === 'logout') {
    logout()
  } else {
    router.push({ path })
  }
}

const linkTo = (type, path) => {
  if (type === 'name') {
    router.push({ name: path })
  } else {
    window.open(path, '_self')
  }
  isShowNpMenu.value = false
}

const onClickOutside = (e) => {
  // console.log('e', e)
  if (isVisibleAccountMenu.value) {
    isVisibleAccountMenu.value = false
  }
  if (isShowNpMenu.value) {
    isShowNpMenu.value = false
  }
}

const groupSitelink = computed(() => {
  return `${JCLA_GROUP_DOMAIN}`
})

const logout = () => {
  resetAuth()
  window.location.href = '/index.html'
}
</script>

<template>
  <header class="commonHeader">
    <div class="container">
      <a href="/">
        <img class="logo" src="@assets/images/header_rogo.png">
        <h1>継続的研修</h1>
      </a>
      <button
        class="spNavBtn"
        @click.stop="toggleSpMenu"
      />
      <div
        :class="[userLogging ? 'loggined' : '', isShowNpMenu ? 'active' : '']"
        class="headerBtnContainer"
      >
        <a
          v-if="!userLogging"
          :href="groupSitelink"
          class="group"
        >
          団体管理者様<br>ログイン・新規登録
        </a>
        <router-link  
          v-if="!userLogging"
          :to="{ name: 'Login' }">個人登録者様<br>ログイン・新規登録
        </router-link>
      </div>
      <div
        v-if="userLogging"
        class="headerBtnContainer account"
      >
        <button
          class="account"
          @click.stop="isVisibleAccountMenu = !isVisibleAccountMenu"
        />
      </div>
      <div
        v-if="isVisibleAccountMenu"
        class="headerAccountMenu">
        <ul>
          <li
            v-for="(item, index) in accountMenu"
            :key="'account' + index"
            @click="accountMenuClick(item.path)"
          >
            {{ item.name}}
          </li>
        </ul>
      </div>
    </div>
    <nav
      class="mainMenu"
      :class="isShowNpMenu ? 'active' : ''"
    >
      <div class="container">
        <!-- ログイン状態 -->
        <ul v-if="userLogging" class="navUl">
          <li><a @click="linkTo('name', 'Dashboard')"><span>マイページ</span></a></li>
          <li><a @click="linkTo('name', 'History')"><span>受講履歴</span></a></li>
          <li><a @click="linkTo('path', '/index.html#attention')"><span>注意点</span></a></li>
          <li><a @click="linkTo('path', '/index.html#completed')"><span>修了者の皆様へ</span></a></li>
          <li><a @click="linkTo('name', 'Inquiry')"><span>お問い合わせ</span></a></li>
          <li><a @click="linkTo('path', '/faq.html')"><span>FAQ</span></a></li>
        </ul>
        <!-- 未ログイン状態 -->
        <ul v-else class="navUl">
          <li><a @click="linkTo('path', '/index.html')"><span>トップページ</span></a></li>
          <li><a @click="linkTo('path', '/index.html#schedule')"><span>開催スケジュール<br>・申し込み</span></a></li>
          <li><a @click="linkTo('path', '/index.html#attention')"><span>注意点</span></a></li>
          <li><a @click="linkTo('path', '/index.html#completed')"><span>修了者の皆様へ</span></a></li>
          <li><a @click="linkTo('name', 'Inquiry')"><span>お問い合わせ</span></a></li>
          <li><a @click="linkTo('path', '/faq.html')"><span>FAQ</span></a></li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<style scoped lang="scss">
.container {
  position: relative;
  z-index: 10;
  justify-content: end;
  
  > a {
    position: absolute;
    left: 0;
    top: 10px;
  }

  .headerBtnContainer.loggined {
    margin-right: 20px;
  }
}
.account {
  background: #fff url('@assets/images/icon/icon-person-circle.svg') no-repeat 10px center;
  background-size: 20px 20px;
  width: 40px;
  height: 40px;
}
.mainMenu {
  position: relative;
  z-index: 1;
}
.headerAccountMenu {
  display: block;
  position: absolute;
  top: 60px;
  right: 0;
  z-index: 11;
  background: #FFF;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  
  li {
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    cursor: pointer;
  }
}

@media (max-width: 992px) {
  .container {
    max-width: 100%;
    position: relative;
    z-index: 10;
    justify-content: space-between;
    
    > a {
      position: relative;
      left: initial;
      top: initial;
    }

    .headerBtnContainer.account {
      position: absolute;
      top: 8px;
      right: 60px;
      left: auto;
    }
  }

  .headerBtnContainer.loggined {
    display: none;

    &.active {
      display: block;
    }

    a {
      width: 100%;
    }
  }
}
</style>
